import api from './api';
import {
  AI_INTEGRATION_ID_STORAGE_KEY,
  environment,
  FALLBACK_AI_INTEGRATION_ID,
} from '../environments/environment';

type AiIntegrationTag = { key: string; value: string };

type AiIntegrationResponse =
  | string
  | { aiIntegrationId?: string; aiintegrationid?: string; aiintegrationId?: string };

const AI_INTEGRATION_BY_TAGS_URL = `${(
  (import.meta.env.VITE_apiBaseUrl as string | undefined)?.trim() || environment.apiBaseUrl
)
  .replace(/\/+$/, '')
  .replace(/\/api\/v\d+$/i, '')}/api/AiIntegration/GetAiIntegrationIdByTags`;

let pendingRequest: Promise<string | null> | null = null;

function extractAiIntegrationId(data: AiIntegrationResponse): string | null {
  return typeof data === 'string' ? data.trim() : '';
}

export function buildAiIntegrationTags(): AiIntegrationTag[] {  
  return [  
    { key: 'SCREEN.TYPE', value: 'Standalone' }
  ];
}

/** Resolves the AI integration id by tags once per page load and stores it in sessionStorage. */
export function initializeAiIntegrationId(tags: AiIntegrationTag[]): Promise<string | null> {
  const cachedId = sessionStorage.getItem(AI_INTEGRATION_ID_STORAGE_KEY)?.trim();
  if (cachedId) {
    return Promise.resolve(cachedId);
  }
  pendingRequest ??= api
    .fetch<AiIntegrationResponse>(AI_INTEGRATION_BY_TAGS_URL, {
      method: 'POST',
      body: JSON.stringify(tags),
      headers: {
        'aiintegrationid': FALLBACK_AI_INTEGRATION_ID,
      }
    })
    .then((data) => {
      const aiIntegrationId = extractAiIntegrationId(data);
      if (aiIntegrationId) {
        sessionStorage.setItem(AI_INTEGRATION_ID_STORAGE_KEY, aiIntegrationId);
      } else {
        sessionStorage.setItem(AI_INTEGRATION_ID_STORAGE_KEY, aiIntegrationId === '' ? FALLBACK_AI_INTEGRATION_ID : '');
      }
      return aiIntegrationId;
    })
    .catch((error) => {
      console.error('[aiIntegrationService] Failed to resolve AI integration id', error);
      sessionStorage.setItem(AI_INTEGRATION_ID_STORAGE_KEY, '');
      return null;
    });

  return pendingRequest;
}
